import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Container, Row, Col, FormGroup, Label, InputGroup, Input, Button, Form } from "reactstrap";
import Joi from "joi-browser";
import { toastBigInfo } from "components/utils/toasts";
import { getPedido, savePedido } from "services/pedidoService";
import moment from "moment";
import "moment/locale/es.js";

import { getConfig } from "config/config";
import { notifyDelivery } from "services/pedidoService";

const PedidosForm = ({ props, onLoading, onDoneLoading }) => {
  const history = useHistory();
  const location = useLocation();
  const [data, setData] = useState({
    _id: "",
    fecha: "",
    user: null,
    sala: null,
    descripcion: "",
    entregado: false,
  });

  const config = getConfig();

  moment.locale("es", {
    week: {
      dow: 1, // for starrting day from monday
    },
  });

  const fetchData = async (id) => {
    const record = await getPedido(id);
    if (record.entregado) toastBigInfo("Atención!", "Este pedido ya fue entregado!");
    mapToViewModel(record);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    const id = props.match.params.id;
    // if (!id.includes("nuev")) {
    fetchData(id);
    // } else {
    //   setAction("A");
    // }
  }, []);

  const mapToViewModel = (pedido) => {
    setData({
      _id: pedido._id,
      fecha: pedido.fech,
      user: pedido.user,
      sala: pedido.sala,
      foto: pedido.foto ? pedido.foto : "",
      descripcion: pedido.descripcion,
      entregado: pedido.entregado,
    });
  };

  //   const handleChange = (event) => {
  //     const input = event.currentTarget;
  //     const inputMode = event.target.inputMode;
  //     const cacheErrors = { ...errors };
  //     const cacheData = { ...data };
  //     if (validateForm) {
  //       const errorMessage = validateProperty(input, inputMode);
  //       if (errorMessage) {
  //         cacheErrors[input.name] = errorMessage;
  //       } else delete cacheErrors[input.name];
  //     } else delete cacheErrors[input.name];
  //     cacheData[input.name] = input.value;
  //     if (input.type === "checkbox") cacheData[input.name] = input.checked;
  //     setData(cacheData);
  //     setErrors(cacheErrors);
  //   };

  const doSubmit = async () => {
    const datos = { ...data };
    datos.entregado = true;
    try {
      const newId = await savePedido(datos);
      const response = await notifyDelivery(datos);
      history.push({ pathname: "/pedidos" });
    } catch (error) {
      console.log(error);
    }
  };

  const doCancelar = async () => {
    const datos = { ...data };
    datos.cancelado = true;
    try {
      const newId = await savePedido(datos);
      const respondse = await notifyDelivery(datos);
      history.push({ pathname: "/pedidos" });
    } catch (error) {
      console.log(error);
    }
  };

  const goBack = () => {
    // history.goBack();
    history.push({ pathname: "/pedidos" });
  };

  return (
    <>
      <Container className="wrapper">
        {data._id && (
          <form onSubmit={doSubmit}>
            <h4 className="mt-4 mb-2">Pedido</h4>

            <Row>
              <Col md="4"></Col>
              <Col md="4">
                <div className="info">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="60px"
                      height="60px"
                      viewBox="0 0 18 18"
                    >
                      <path
                        d="M3.75 6.75H14.25V10.25C14.25 13.01 12.01 15.25 9.25 15.25H8.75C5.99 15.25 3.75 13.01 3.75 10.25V6.75Z"
                        fill="#1c1f21"
                        fillOpacity="0.3"
                        data-color="color-2"
                        data-stroke="none"
                      ></path>{" "}
                      <path
                        d="M8.75 0.75C8.728 1.381 8.584 2.133 8.078 2.75C7.731 3.174 7.442 3.254 7.109 3.672C6.987 3.825 6.87 4.01 6.771 4.236"
                        stroke="#1c1f21"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                      ></path>{" "}
                      <path
                        d="M11.5 2.75C11.485 3.129 11.389 3.58 11.052 3.95C10.925 4.09 10.81 4.167 10.695 4.25"
                        stroke="#1c1f21"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                      ></path>{" "}
                      <path
                        d="M3.75 6.75H14.25V10.25C14.25 13.01 12.01 15.25 9.25 15.25H8.75C5.99 15.25 3.75 13.01 3.75 10.25V6.75Z"
                        stroke="#1c1f21"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                      ></path>{" "}
                      <path
                        d="M15.25 15.25H2.75"
                        stroke="#1c1f21"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                      ></path>{" "}
                      <path
                        d="M14.25 6.75H15.25C16.355 6.75 17.25 7.641 17.25 8.75C17.25 9.859 16.355 10.75 15.25 10.75H14.25"
                        stroke="#1c1f21"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                      ></path>
                    </svg>
                    {/* <i className="nc-icon nc-delivery-fast" /> */}
                  </div>
                  <div className="description">
                    <h4 className="info-title">{data.sala.descripcion}</h4>
                    <h6 className="info-title">{data.user.nombre + " " + data.user.apellido}</h6>
                    <h6>{moment(data.fecha).format("D [de] MMMM [de] YYYY - HH:mm")}</h6>
                    <p>{data.descripcion}</p>
                  </div>
                </div>
              </Col>
              <Col md="4"></Col>
            </Row>

            <Row className="justify-content-center mt-5">
              {!data.entregado && (
                <Button outline className="btn-round mr-1" color="success" type="button" onClick={doSubmit}>
                  Entregado
                </Button>
              )}
              {!data.entregado && (
                <Button outline className="btn-round mr-1" color="danger" type="button" onClick={doCancelar}>
                  Cancelado
                </Button>
              )}
              <Button outline className="btn-round mr-1" color="info" type="button" onClick={goBack}>
                Salir
              </Button>
            </Row>
          </form>
        )}
      </Container>
    </>
  );
};

export default PedidosForm;
